import React, { Component } from 'react';

import './Checkbox.css';

class Checkbox extends Component {

  constructor(props){
    super(props);

    this.checked = (this.props.checked) ? "checked" : false;
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(props, state){
    this.checked = (props.checked) ? "checked" : false;

  }
  handleChange(e){
    const target = e.target;
    var val = target.checked;

    let prop = (this.props.id)? this.props.id : target;



    this.props.onChange(prop, val);
  }

  render() {

    return (
      <label className="checkbox-wrapper">

        <input
          type="checkbox" name={'checkbox-' + (this.props.id)}
          value="0"
          checked={this.checked}
          onChange={this.handleChange}
          />

          {this.props.label}

      </label>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/Checkbox.js